(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kaalvoid-cart-experience"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-kv-cart-recommendations]');

  roots.forEach((root) => {
    if (root.dataset.kvLoaded === 'true') return;

    root.dataset.kvLoaded = 'true';

    const grid = root.querySelector('[data-kv-cart-recommendations-grid]');
    const ids = (root.dataset.productIds || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);

    if (!grid || !ids.length) {
      root.hidden = true;
      return;
    }

    const products = new Map();

    const getRecommendations = (productId) => {
      const rootUrl =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      const url =
        rootUrl +
        'recommendations/products.json?product_id=' +
        encodeURIComponent(productId) +
        '&limit=8&intent=related';

      return fetch(url, {
        headers: {
          Accept: 'application/json'
        }
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Recommendation request failed');
          }

          return response.json();
        })
        .then((data) => {
          (data.products || []).forEach((product) => {
            if (!product || products.has(product.id)) return;

            if (ids.includes(String(product.id))) return;

            products.set(product.id, product);
          });
        });
    };

    Promise.all(ids.map(getRecommendations))
      .then(() => {
        const recommended = Array.from(products.values()).slice(0, 4);

        if (!recommended.length) {
          root.hidden = true;
          return;
        }

        grid.innerHTML = '';

        recommended.forEach((product) => {
          const card = document.createElement('a');
          card.className = 'kv-cart-recommendation';
          card.href = product.url;

          const imageWrap = document.createElement('div');
          imageWrap.className = 'kv-cart-recommendation__image';

          const imageUrl =
            product.featured_image ||
            (product.images && product.images.length ? product.images[0] : '');

          if (imageUrl) {
            const image = document.createElement('img');
            image.src = imageUrl;
            image.alt = product.title || '';
            image.loading = 'lazy';
            imageWrap.appendChild(image);
          }

          const meta = document.createElement('div');
          meta.className = 'kv-cart-recommendation__meta';

          const title = document.createElement('span');
          title.textContent = product.title || '';

          const price = document.createElement('strong');

          if (
            window.Shopify &&
            typeof window.Shopify.formatMoney === 'function'
          ) {
            price.textContent = window.Shopify.formatMoney(product.price);
          } else {
            price.textContent = product.price || '';
          }

          meta.appendChild(title);
          meta.appendChild(price);

          card.appendChild(imageWrap);
          card.appendChild(meta);
          grid.appendChild(card);
        });
      })
      .catch(() => {
        root.hidden = true;
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
